import ApplicationController from "./application_controller"
import Logger from '../lib/logger'

export default class extends ApplicationController {
  static targets = ["toggleIcon", "toggleText", "toggleButton", "icon", "status"]
  static values = { hasActiveFilters: Boolean }

  connect() {
    super.connect()
    if (!this.hasToggleButtonTarget) {
      Logger.warn("CollapsibleController: Missing 'toggleButton' target - toggle functionality disabled")
      return
    }

    this._handleKeydown = this.handleKeydown.bind(this)
    this.toggleButtonTarget.addEventListener('keydown', this._handleKeydown)
    this.updateButtonState()
  }

  disconnect() {
    if (this.hasToggleButtonTarget && this._handleKeydown) {
      this.toggleButtonTarget.removeEventListener('keydown', this._handleKeydown)
    }
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggle()
    }
  }

  toggle() {
    if (this.hasToggleButtonTarget) {
      const isExpanded = this.toggleButtonTarget.getAttribute('aria-expanded') === 'true'
      if (isExpanded) {
        this.hide()
      } else {
        this.show()
      }
    }
  }

  show() {
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute('aria-expanded', 'true')
      this.updateButtonState()
    }
  }

  hide() {
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute('aria-expanded', 'false')
      this.updateButtonState()
    }
  }

  updateButtonState() {
    if (!this.hasToggleButtonTarget) return

    const isExpanded = this.toggleButtonTarget.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.remove('fa-chevron-down')
        this.toggleIconTarget.classList.add('fa-chevron-up')
      }
      if (this.hasToggleTextTarget) {
        this.toggleTextTarget.textContent = 'Hide'
      }
    } else {
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.remove('fa-chevron-up')
        this.toggleIconTarget.classList.add('fa-chevron-down')
      }
      if (this.hasToggleTextTarget) {
        this.toggleTextTarget.textContent = 'Show'
      }
    }

    this.updateIcon(isExpanded)
    this.updateStatus(isExpanded)
  }

  updateIcon(isExpanded) {
    if (this.hasIconTarget) {
      const icon = this.iconTarget
      if (isExpanded) {
        icon.classList.remove('fa-chevron-down')
        icon.classList.add('fa-chevron-up')
      } else {
        icon.classList.remove('fa-chevron-up')
        icon.classList.add('fa-chevron-down')
      }
    }
  }

  updateStatus(isExpanded) {
    if (this.hasStatusTarget) {
      const statusElement = this.statusTarget
      if (isExpanded) {
        statusElement.innerHTML = '<i class="fas fa-eye me-1"></i>Visible'
        statusElement.className = 'badge theme-badge-success ms-2'
      } else {
        statusElement.innerHTML = '<i class="fas fa-eye-slash me-1"></i>Hidden'
        statusElement.className = 'badge theme-badge-secondary ms-2'
      }
    }
  }
}
